(function() {

    const elements = document.querySelectorAll('.mod24SupportBlockFlexible');

    for (let j = 0; j < elements.length; j++) {
        const ele = elements[j];
        new window.Vue({
            el: ele,
            data: {
                formData: {
                    body: '',
                    name: '',
                    email: '',
                    challenge: '',
                },
                bIsError: false,
                aErrorMsg: [],
                oErrors: {
                    'name': 'Bitte geben Sie Ihren Namen zur Bearbeitung Ihrer Anfrage an.',
                    'email': 'Bitte geben Sie eine gültige E-Mail-Adresse zur Bearbeitung Ihrer Anfrage an.',
                    'body': 'Bitte geben Sie eine Nachricht zur Bearbeitung Ihrer Anfrage an.',
                    'generic': 'Ein Fehler ist aufgetreten. Bitte probieren Sie es später erneut.',
                },
                bShowNotification: false,
            },
            mounted() {
                this.formData.name = ele.querySelector('[name=name]')?.value ?? '';
                this.formData.email = ele.querySelector('[name=email]')?.value ?? '';
                this.formData.challenge = ele.querySelector('[name=challenge]')?.value ?? '';
            },
            methods: {
                fnSubmitForm: async function(e) {
                    const self = this;
                    e.preventDefault();

                    self.fnValidateForm();

                    if (self.bIsError) {
                        return;
                    }

                    const formPayload = new FormData();

                    for (const key in this.formData) {
                        formPayload.append(key, this.formData[key]);
                    }

                    formPayload.append('category', window.c24Lp.getMatomoEventCategory());
                    formPayload.append('block', 'standard');

                    fetch(
                        window.c24LpRoot + 'api/?k=24&a=support',
                        {
                            method: 'POST',
                            body: formPayload,
                        },
                    ).then(async (response) => {

                        if (!response.ok || response.status !== 200) {
                            throw {
                                errorType: 'serverError',
                                errorObject: response,
                            };
                        }

                        const data = await response.json();
                        if (data?.success !== true) {
                            throw {
                                errorType: 'apiError',
                                errorObject: data,
                            };
                        }

                        self.bShowNotification = true;
                    }).catch(({
                        errorType, errorObject,
                    } = {}) => {
                        window.c24Lp.logError('c24SupportBlock flexible | ' + errorType, errorObject);

                        this.fnThrowError();
                    });

                },
                fnValidateForm: function() {
                    this.aErrorMsg = [];
                    this.bIsError = false;

                    this.fnValidateEmail();
                    this.fnValidateName();
                    this.fnValidateMessage();
                },
                fnValidateEmail: function() {
                    const emailReg = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[.a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]{2,6})$/;
                    if (!emailReg.test(this.formData.email)) {
                        this.fnThrowError('email');
                    }
                },
                fnValidateName: function() {
                    const regName = /^[a-zäöüß ,.'-]+$/i;
                    if (!regName.test(this.formData.name)) {
                        this.fnThrowError('name');
                    }
                },
                fnValidateMessage: function() {
                    if (!this.formData.body) {
                        this.fnThrowError('body');
                    }
                },
                fnSuccess: function() {
                    this.bShowNotification = true;
                },
                fnCloseNotification: function() {
                    this.bShowNotification = false;
                },
                fnThrowError: function(sType) {
                    sType = (sType) ? sType : 'generic';
                    const sErrorMsg = (this.oErrors[sType]) ? this.oErrors[sType] : this.oErrors.generic;

                    this.aErrorMsg.push(sErrorMsg);
                    this.bIsError = true;
                },
            },
        });
    }

    $(document).ready(function() {
        $.each($('.mod24SupportBlock form'), function() {
            const form = $(this);
            const textarea = $('textarea', form);

            if (textarea.val() !== '') {
                $('button', form).prop('disabled', false);
            }

            textarea.on(
                'keyup paste input',
                function() {
                    $('button', form).prop('disabled', textarea.val() === '');
                },
            );

            $('.mod24SupportBlock .notification').on('click', function() {
                const block = $(this).closest('.mod24SupportBlock');
                const textarea = $('textarea', block);
                const emailField = $('input[name=email]', block);
                const button = $('button', block);
                const notification = $('.notification', block);

                notification.stop().fadeOut('slow');
                textarea.prop('disabled', false);
                textarea.val('');
                emailField.prop('disabled', false);
                button.prop('disabled', true);
            });

            form.on('submit', function(e) {
                e.preventDefault();
                const textarea = $('textarea', e.target);
                const message = textarea.val();
                const emailField = $('input[name=email]', e.target);
                const email = emailField.val().trim();
                const blockParam = $('input[name=block]', e.target).val();
                const nameField = $('input[name=name]', e.target);
                const name = nameField.val().trim();
                const numberField = $('input[name=number]', e.target);
                const number = numberField.val().trim();
                const errorEmail = $('.errorEmail', e.target);
                const emailReg = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[.a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]{2,6})$/;
                const mobilReg = /^(?:([+][0-9]{1,10})+[ .-]*)?(:[-])?([(]{1}[0-9]{1,6}[)])?([0-9 .-/]{7,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/;
                const errorName = $('.errorName', e.target);
                const numberName = $('.errorNumber', e.target);
                const challengeField = $('input[name=challenge]', e.target);
                const challenge = challengeField.val().trim();

                let nameNotEmpty = false;
                let mobileNotEmpty = false;

                if (name == '') {
                    errorName.stop().fadeIn('slow');
                } else {
                    nameNotEmpty = true;
                    errorName.stop().fadeOut('slow');
                }

                if (!mobilReg.test(number)) {
                    numberName.stop().fadeIn('slow');
                } else {
                    mobileNotEmpty = true;
                    numberName.stop().fadeOut('slow');
                }

                if (!emailReg.test(email)) {
                    errorEmail.stop().fadeIn('slow');
                } else {
                    errorEmail.stop().fadeOut('slow');

                    if (mobileNotEmpty && nameNotEmpty) {
                        textarea.prop('disabled', true);
                        emailField.prop('disabled', true);
                        $('button', form).prop('disabled', true);
                        $('.js24LoadingAction', form).show();

                        $.post(
                            window.c24LpRoot + 'api/?k=24&a=support',
                            {
                                block: blockParam,
                                email: email,
                                name: name,
                                number: number,
                                body: message,
                                category: window.c24Lp.getMatomoEventCategory(),
                                challenge: challenge,
                            },
                            function() {
                                $('.js24LoadingAction', form).hide();
                                $('.notification', form).stop().fadeIn('slow');
                            },
                        );
                    }
                }
            });
        });
    });
})();
